/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
// import _ from "lodash";
import { Trans } from "react-i18next";
import Select from "react-select";
import requireAuth from "components/hoc/requireAuth";
import { showModal, getEvolutionPlanEmployees } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import EvolutionPlanTrainingCompletionRatio from "components/widgets/stats/EvolutionPlanTrainingCompletionRatio";
import EvolutionPlanDetail from "components/evolutionPlan/EvolutionPlanDetail";
import i18n from "i18next";

class EvolutionPlan extends Component {
  state = {
    selectedDepartment: null,
    selectedEmployee: null,
    showCompletedTrainings: false,
    employeeOptionsList: [],
    isManager: localStorage.getItem("roles").includes("Manager"),
  };

  componentDidMount = () => {
    this.props.onProcessBegin();
    if (this.props.guide.length !== 0 && this.props.profile.general.id) {
      this.setSelectedEmployeeAndDepartment();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.guide !== this.props.guide) {
      this.setSelectedEmployeeAndDepartment();
    }

    if (
      prevProps.evolutionPlan !== this.props.evolutionPlan &&
      this.props.evolutionPlan.employees
    ) {
      const options = this.props.evolutionPlan.employees.map((e) => {
        return { value: e.id, label: e.fullname };
      });

      this.setState({
        employeeOptionsList: options,
      });
    }

    if (
      prevState.selectedDepartment !== this.state.selectedDepartment &&
      prevState.selectedDepartment
    ) {
      this.fetchEmployees(this.state.selectedDepartment);
    }
  }

  setSelectedEmployeeAndDepartment = () => {
    let selectedDepartment = null;
    const selectedEmployee = this.props.match.params
      ? this.props.match.params.userid
        ? this.props.match.params.userid
        : this.props.profile.general.id
      : this.props.profile.general.id;

    const employeeOnGuide = this.props.guide.data.find(
      (c) => c.id === selectedEmployee
    );

    if (employeeOnGuide) {
      selectedDepartment = employeeOnGuide.serviceType.value
        ? employeeOnGuide.serviceType.value
        : null;
    } else {
      //default olarak satış seçilsin
      selectedDepartment = 50022; //satış
    }

    this.fetchEmployees(selectedDepartment);

    this.setState({ selectedEmployee, selectedDepartment });
    // this.props.onProcessEnd();
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };
  onSuccess = () => {
    this.props.onProcessEnd();
  };
  onError = (err) => {
    this.props.onProcessEnd();
  };

  fetchEmployees = (dept) => {
    if (this.state.isManager) {
      this.props.getEvolutionPlanEmployees(
        dept,
        this.onBegin,
        this.onSuccess,
        this.onError
      );
    } else this.onSuccess();
  };

  handleDepartmentSelect = (e) => {
    this.setState({ selectedDepartment: e.value, selectedEmployee: null });
  };

  handleEmployeeSelect = (e) => {
    this.setState({ selectedEmployee: e.value });
  };

  toggleShowCompletedTrainings = () => {
    const showCompletedTrainings = !this.state.showCompletedTrainings;
    this.setState({ showCompletedTrainings });
  };

  renderDepartmentCombo = () => {
    const isDisabled = !this.state.isManager;

    /*
      MechanicalS = 10049;
      Body / PaintS = 10050
      SalesS = 10047
      Service Administration = 10048
    */

    const options = [
      { value: "50020", label: i18n.t("10049") },
      { value: "50021", label: i18n.t("10050") },
      { value: "50022", label: i18n.t("10047") },
      { value: "50023", label: i18n.t("10048") },
    ];

    return (
      <Select
        placeholder={i18n.t("10521")}
        isDisabled={isDisabled}
        options={options}
        onChange={(e) => this.handleDepartmentSelect(e)}
        // defaultValue={options[0]}
        value={options.find(
          (o) => o.value === String(this.state.selectedDepartment)
        )}
      />
    );
  };

  renderEmployeesCombo = () => {
    console.log(this.state.selectedEmployee);
    console.log(this.state.selectedDepartment);
    const isDisabled = !this.state.isManager;
    if (isDisabled) {
      const options = [
        {
          value: this.props.profile.general.id,
          label: this.props.profile.general.fullname,
        },
      ];
      return (
        <Select
          placeholder={i18n.t("10521")}
          isDisabled={isDisabled}
          options={options}
          value={options.find((o) => o.value === this.props.profile.general.id)}
        // defaultValue={this.state.employeeOptionsList[0]}
        />
      );
    }
    return (
      <Select
        placeholder={i18n.t("10521")}
        label="ee"
        options={this.state.employeeOptionsList}
        onChange={(e) => this.handleEmployeeSelect(e)}
        value={
          this.state.selectedEmployee
            ? this.state.employeeOptionsList.find(
              (o) => o.value === this.state.selectedEmployee
            )
            : null
        }
      // defaultValue={this.state.employeeOptionsList[0]}
      />
    );
  };

  renderShowCompletedCheckbox = () => {
    let icon = this.state.showCompletedTrainings
      ? "iconmford fo-icon-check"
      : "iconmford fo-icon-clear";
    return (
      <div className="alertIcon">
        <span className={icon}></span>
      </div>
    );
  };

  renderEmployeeData = () => {
    if (!this.state.selectedEmployee) return null;

    return (
      <>
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-8 col-lg-9 p-0 dashboardWidgetArea">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="fgaAlert redAlert mt-0">
                  <div className="alertIcon">
                    <span className="iconmford fo-icon-warning"></span>
                  </div>
                  <div className="alertText align-middle">
                    <p>
                      <Trans
                        desc="Gelecek dönem eğitim yeterliliği 05.07.2023 itibaren
                      devreye girecektir."
                      >
                        10141
                      </Trans>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <a
                  href="#"
                  onClick={() => this.toggleShowCompletedTrainings()}
                  className="fgaAlert successAlert d-block"
                >
                  {this.renderShowCompletedCheckbox()}
                  <div className="alertText align-middle">
                    <p>
                      <Trans desc="Tamamlanmış Eğitimleri Göster / Gizle">
                        10142
                      </Trans>
                    </p>
                  </div>
                </a>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 mt-2 mb-3">
                <ul className="colorInfoMenu">
                  <li className="green">
                    <Trans desc="Tamamlanmış Eğitim">10144</Trans>
                  </li>
                  <li className="orange">
                    <Trans desc="Kayıtlı Eğitim">10145</Trans>
                  </li>
                  <li className="red">
                    <Trans desc="Tekrarlanması Gereken Eğitim">10146</Trans>
                  </li>
                  <li className="darkblue hedeflenenPozisyonicon">
                    <Trans desc="Hedeflenen Pozisyon">10147</Trans>
                  </li>
                  <li className="darkblue rolicon">
                    <Trans desc="Ford Rol">10148</Trans>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-4 col-lg-3 p-0 dashboardWidgetArea">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <EvolutionPlanTrainingCompletionRatio
                  classNames=" yeterlilikGrafik gelisimPlaniETO"
                  employeeId={this.state.selectedEmployee}
                />
              </div>
            </div>
          </div>
        </div>
        <EvolutionPlanDetail
          showCompleted={this.state.showCompletedTrainings}
          employeeId={this.state.selectedEmployee}
        />
      </>
    );
  };

  renderPosition = () => {
    if (!this.state.selectedEmployee) return null;

    if (!this.state.isManager) {
      return this.props.profile.general.position;
    }
    return this.props.evolutionPlan?.employees?.find(
      (e) => e.id === this.state.selectedEmployee
    )?.position?.name;
  };

  render() {
    return (
      // <div>
      //   {this.state.selectedEmployee}
      //   <br />
      //   {this.state.selectedDepartment}
      // </div>
      <section className="profilArea my-3">
        {this.props.spinner}
        <div className="container">
          <div className="row py-4 topRow align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4 d-none d-sm-none d-md-flex d-lg-flex">
              <ul className="fgaBreadcrumb">
                <li>
                  <a href="/" style={{ verticalAlign: "middle" }}>
                    <span className="iconmford fo-icon-home"></span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <Trans desc="Eğitim ve Gelişim">10025</Trans>
                  </a>
                </li>
                <li className="active">
                  <Trans desc="Gelişim Planı">10035</Trans>
                </li>
              </ul>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4 d-flex d-sm-flex d-md-none d-lg-none">
              <div className="sssBaslik">
                <Trans desc="Gelişim Planı">10035</Trans>
              </div>
            </div>
          </div>
          <div className="row py-4 bottomRow">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="row calculateArea">
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
                  <div className="form-row align-items-center">
                    <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                      <label htmlFor="departmanSeciniz">
                        <Trans desc="Departman Seçiniz">10138</Trans>:
                      </label>
                    </div>
                    <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                      {this.renderDepartmentCombo()}
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
                  <div className="form-row align-items-center">
                    <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                      <label htmlFor="seciliPersonel">
                        <Trans desc="Seçili Personel">10139</Trans>:
                      </label>
                    </div>
                    <div className="col-xs-12 col-sm-7 col-md-7 col-lg-7">
                      {this.renderEmployeesCombo()}
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 my-1">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div className="form-row align-items-center my-2">
                      <label htmlFor="seciliPersonel" className="pl-2">
                        <Trans desc="Pozisyon">10140</Trans>:
                      </label>
                      <p id="seciliPersonel" className="mb-0 pl-2">
                        {this.renderPosition()}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <hr className="my-4" />
                </div>
              </div>
              {this.renderEmployeeData()}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    application: state.application,
    evolutionPlan: state.evolutionPlan.data,
    guide: state.guide,
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {
  showModal,
  getEvolutionPlanEmployees,
})(requireAuth(containsLongRunningProcess(EvolutionPlan)));
